import { PlusIcon } from "lucide-react";

import { Link } from "@/components/Link";
import type { ProcessTemplate } from "../../types";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function ProcessTable({
  templates,
}: {
  templates: ProcessTemplate[] | undefined;
}) {
  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "processes",
    templates,
    [
      {
        field: "name",
        headerName: "Name",
        cellRenderer: (params) => (
          <Link to="/admin/processes/$id" params={{ id: params.data.id }}>
            {params.data.name}
          </Link>
        ),
      },
      {
        field: "description",
        headerName: "Description",
      },
      {
        colId: "latestVersion",
        headerName: "Latest version",
        valueGetter: (params) => params.data?.versions[0]?.version ?? "-",
      },
      {
        field: "versions",
        headerName: "Versions",
        valueGetter: (params) => params.data?.versions.length ?? 0,
      },
    ],
    { sideBar: undefined },
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link to="/admin/processes/new" asButton>
          <PlusIcon data-slot="icon" />
          Add process
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
